// export const DATABOARD_URL = process.env.VUE_APP_API_DATA_URL;
// export const OPAC_URL = process.env.VUE_APP_API_SEARCH_URL;

export const BASE_URL = window.APP_CONFIG?.VUE_APP_API_BASE_URL;
export const DATABOARD_URL = window.APP_CONFIG?.VUE_APP_API_DATA_URL;
export const OPAC_URL = window.APP_CONFIG?.VUE_APP_API_SEARCH_URL;
export const ICON_URL = window.APP_CONFIG?.VUE_APP_API_ICON_URL;